import { render, staticRenderFns } from "./OrganizationEcom.vue?vue&type=template&id=3fc6c38c&scoped=true"
import script from "./OrganizationEcom.vue?vue&type=script&lang=js"
export * from "./OrganizationEcom.vue?vue&type=script&lang=js"
import style0 from "./OrganizationEcom.vue?vue&type=style&index=0&id=3fc6c38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6c38c",
  null
  
)

export default component.exports